export const windowHasFocus = (state) => state.focus.focused;
